import { render, staticRenderFns } from "./ProviderNav.vue?vue&type=template&id=64564af5"
import script from "./ProviderNav.vue?vue&type=script&lang=js"
export * from "./ProviderNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports